"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationInstanceEmailStatus;
(function (CommunicationInstanceEmailStatus) {
    CommunicationInstanceEmailStatus["Created"] = "Created";
    CommunicationInstanceEmailStatus["Processed"] = "Processed";
    CommunicationInstanceEmailStatus["ProcessError"] = "ProcessError";
    CommunicationInstanceEmailStatus["Queued"] = "Queued";
    CommunicationInstanceEmailStatus["QueueError"] = "QueueError";
    CommunicationInstanceEmailStatus["Delivered"] = "Delivered";
    CommunicationInstanceEmailStatus["Bounced"] = "Bounced";
    CommunicationInstanceEmailStatus["Opened"] = "Opened";
})(CommunicationInstanceEmailStatus = exports.CommunicationInstanceEmailStatus || (exports.CommunicationInstanceEmailStatus = {}));
//# sourceMappingURL=CommunicationInstanceEmailStatus.js.map